module.exports = __webpack_public_path__ + "static/media/Aryan-Holding-Group-Logo-2.0f32621a.png";